import React, { useState } from 'react'
import { createPortal } from 'react-dom'
import { useAuth } from '../../contexts/AuthContext'
import './VerifyEmailModal.css'

export default function VerifyEmailModal({ isOpen, onClose }) {
  const { resendVerificationEmail, user } = useAuth()
  const [status, setStatus] = useState('idle') // idle, sending, sent, error
  const [error, setError] = useState(null)

  if (!isOpen) return null

  const handleSendVerification = async () => {
    try {
      setStatus('sending')
      // Pass the current window location as the redirect URL
      const redirectUrl = window.location.href
      const { error } = await resendVerificationEmail(redirectUrl)
      
      if (error) throw new Error(error)
      
      setStatus('sent')
    } catch (err) {
      console.error('Failed to send verification email:', err)
      setStatus('error')
      setError(err.message || 'Failed to send verification email')
    }
  }

  return createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Verify Your Email</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        
        <div className="modal-body">
          <p>Email verification is required to join tournaments.</p>
          <p className="modal-description">
            Please verify your email address <strong>{user?.email}</strong> to continue.
          </p>

          {status === 'sent' ? (
             <div className="success-message" style={{ color: '#22c55e', marginTop: '1rem', textAlign: 'center' }}>
               <p><strong>Verification email sent!</strong></p>
               <p>Check your inbox and click the link to verify.</p>
               <p style={{ fontSize: '0.9em', marginTop: '0.5rem' }}>After verifying, refresh this page.</p>
             </div>
          ) : (
             <>
               {error && <div className="error-message" style={{ marginBottom: '1rem' }}>{error}</div>}
               <button 
                 className="modal-action-btn"
                 onClick={handleSendVerification}
                 disabled={status === 'sending'}
                 style={{ width: '100%', marginTop: '1rem' }}
               >
                 {status === 'sending' ? 'Sending...' : 'Send Verification Email'}
               </button>
             </>
          )}
        </div>
      </div>
    </div>,
    document.body
  )
}
